import util from '../../utils/util';
import lazyload from '../../utils/lazyload';
import ConstructorIOSearch from '../search';

const enhanceProduct = {
    /**
     * Is slider on PLP tiles enabled for mobile
     *
     * @returns {boolean} - true if slider is enabled
     */
    isSliderTilesPLPEnabled() {
        return (
            window.SitePreferences.ENABLE_PLP_SWIPE_ON_MOBILE &&
            ConstructorIOSearch.isEnabled &&
            util.isMobileOrTablet()
        );
    },
    /**
     *  Enhance first(6) products with slider images, more will be loaded on scrolling
     *
     * @param {Object} result - search result
     * @returns {Object} - search result with enhanced
     */
    async enhance(result) {
        if (enhanceProduct.isSliderTilesPLPEnabled()) {
            const sliderImagesCount = 6; // load only 6 slider images, so it not hit too many requests

            const sliderImagesPromises = result.products
                .slice(0, sliderImagesCount)
                .map(product =>
                    fetch(`${Urls?.getSliderImagesPLP}?pid=${product.ID}`).then(response => response.text())
                );

            const sliderImages = await Promise.all(sliderImagesPromises);

            sliderImages.forEach((images, index) => {
                result.products[index].sliderImagesHTML = images;
            });
        }
        return result;
    },

    /**
     * Init sliders on mobile
     */
    initSliders() {
        $('.slick-plp')
            .not('.slick-initialized')
            .slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                adaptiveHeight: true,
                autoplay: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots: true,
                            dotsClass: 'slick-dots-custom'
                        }
                    }
                ]
            });
    },
    /**
     *
     */
    afterRender() {
        if (enhanceProduct.isSliderTilesPLPEnabled()) {
            this.initSliders();

            const container = document.querySelector('#search-result-items');
            const tileImages = container.querySelectorAll('.product-image');

            const imageObserver = new IntersectionObserver(entries => {
                entries.forEach(
                    entry => {
                        if (entry.isIntersecting) {
                            const $target = $(entry.target);
                            const productId = $target.data('product-id');
                            enhanceProduct.loadSwipeSlider(productId, $target);
                            imageObserver.unobserve(entry.target);
                        }
                    },
                    {rootMargin: '200px'} // load images 200px before they appear
                );
            });

            tileImages.forEach(image => {
                imageObserver.observe(image);
            });
        }
    },
    /**
     * load Swipe Slider
     *
     * @param {string} productId - product id
     * @param {Object} $target - target element in jquery object
     */
    loadSwipeSlider(productId, $target) {
        fetch(`${Urls?.getSliderImagesPLP}?pid=${productId}`).then(response => {
            if (response.ok) {
                response.text().then(data => {
                    $target.find('.js-product-image-placeholder').html(data);
                    lazyload.init();
                    this.initSliders();
                });
            }
        });
    }
};

export default enhanceProduct;
